import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const Auth = () => {
  const navigate = useNavigate();
  // 新增：支持登录/注册/切换账号三种模式
  const [authMode, setAuthMode] = useState('login'); // login/register/switch
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    username: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // 从路由参数自动识别模式
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('switch')) {
      setAuthMode('switch');
    } else if (path.includes('register')) {
      setAuthMode('register');
    } else {
      setAuthMode('login');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // 清除该字段的错误
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (authMode !== 'switch') { // 切换账号模式不校验表单
      if (!formData.email) {
        newErrors.email = '请输入邮箱地址';
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = '邮箱格式不正确';
      }
      
      if (!formData.password) {
        newErrors.password = '请输入密码';
      } else if (formData.password.length < 6) {
        newErrors.password = '密码至少6位';
      }
      
      if (authMode === 'register') {
        if (!formData.username) {
          newErrors.username = '请输入用户名';
        } else if (formData.username.length < 2) {
          newErrors.username = '用户名至少2位';
        }
        
        if (!formData.confirmPassword) {
          newErrors.confirmPassword = '请确认密码';
        } else if (formData.password !== formData.confirmPassword) {
          newErrors.confirmPassword = '两次输入的密码不一致';
        }
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsLoading(true);
    
    // 模拟API请求
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    console.log(authMode === 'login' ? '登录' : '注册', formData);
    
    if (authMode === 'login') {
      alert('🐕 登录成功！欢迎回来！');
      // 新增：设置登录态到localStorage
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('currentUserId', '1');
    } else {
      alert('✨ 注册成功！开始你的创作之旅吧！');
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('currentUserId', '1');
    }
    
    setIsLoading(false);
    navigate('/');
  };

  const handleSocialLogin = (platform) => {
    console.log(`通过${platform}登录`);
    alert(`通过${platform}登录功能开发中...`);
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  // 切换账号时选择已有账号
  const handleSelectAccount = (accountName) => {
    alert(`已切换到「${accountName}」账号 🐾`);
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('currentUserId', '1');
    navigate('/');
  };

  return (
    <div className="auth-page fade-in">
      <div className="auth-container">
        {/* 左侧装饰 */}
        <div className="auth-left">
          <div className="auth-decoration">
            <div className="decoration-dog">
              <span className="dog-icon">🐕</span>
            </div>
            <div className="decoration-text">
              <h2>欢迎来到 Puppy Log</h2>
              <p>加入温暖的小狗社区，记录生活中的每一份美好</p>
            </div>
            <div className="paw-trail">
              <span className="paw">🐾</span>
              <span className="paw">🐾</span>
              <span className="paw">🐾</span>
              <span className="paw">🐾</span>
            </div>
          </div>
        </div>

        {/* 右侧表单 */}
        <div className="auth-right">
          <div className="auth-form-container">
            {/* 顶部切换：新增切换账号选项 */}
            <div className="auth-switch">
              <button 
                className={`switch-btn ${authMode === 'login' ? 'active' : ''}`}
                onClick={() => setAuthMode('login')}
              >
                <span className="btn-icon">🔑</span>
                登录
              </button>
              <button 
                className={`switch-btn ${authMode === 'register' ? 'active' : ''}`}
                onClick={() => setAuthMode('register')}
              >
                <span className="btn-icon">✨</span>
                注册
              </button>
              <button 
                className={`switch-btn ${authMode === 'switch' ? 'active' : ''}`}
                onClick={() => setAuthMode('switch')}
              >
                <span className="btn-icon">🔄</span>
                切换账号
              </button>
            </div>

            {/* 标题：根据模式动态调整 */}
            <div className="auth-header">
              <h1>
                {authMode === 'login' ? '欢迎回来 🐕' : 
                 authMode === 'register' ? '加入我们 ✨' : '切换账号 🔄'}
              </h1>
              <p className="auth-subtitle">
                {authMode === 'login' ? '登录你的账户，继续创作之旅' : 
                 authMode === 'register' ? '创建新账户，开始记录生活' : '选择其他账号登录'}
              </p>
            </div>

            {/* 切换账号模式：显示账号列表 */}
            {authMode === 'switch' ? (
              <div className="switch-account-list">
                <div className="account-item">
                  <span className="account-avatar">🐶</span>
                  <span className="account-name">咖啡喵</span>
                  <button 
                    className="select-account-btn"
                    onClick={() => handleSelectAccount('咖啡喵')}
                  >
                    选择
                  </button>
                </div>
                <div className="account-item">
                  <span className="account-avatar">🐱</span>
                  <span className="account-name">铲屎官</span>
                  <button 
                    className="select-account-btn"
                    onClick={() => handleSelectAccount('铲屎官')}
                  >
                    选择
                  </button>
                </div>
                <div className="account-item">
                  <span className="account-avatar">👤</span>
                  <span className="account-name">其他账号</span>
                  <button 
                    className="login-other-btn"
                    onClick={() => setAuthMode('login')}
                  >
                    登录
                  </button>
                </div>
              </div>
            ) : (
              // 登录/注册模式：显示表单
              <form onSubmit={handleSubmit} className="auth-form">
                {authMode === 'register' && (
                  <div className="form-group">
                    <div className="form-label-row">
                      <label htmlFor="username" className="form-label">
                        <span className="label-icon">👤</span>
                        用户名
                      </label>
                      <span className="label-hint">2-20个字符</span>
                    </div>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder="输入你的用户名"
                      className={`form-control ${errors.username ? 'error' : ''}`}
                    />
                    {errors.username && (
                      <div className="error-message">
                        <span className="error-icon">⚠️</span>
                        {errors.username}
                      </div>
                    )}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    <span className="label-icon">📧</span>
                    邮箱地址
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="输入你的邮箱"
                    className={`form-control ${errors.email ? 'error' : ''}`}
                  />
                  {errors.email && (
                    <div className="error-message">
                      <span className="error-icon">⚠️</span>
                      {errors.email}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <div className="form-label-row">
                    <label htmlFor="password" className="form-label">
                      <span className="label-icon">🔒</span>
                      密码
                    </label>
                    {authMode === 'login' && (
                      <button 
                        type="button" 
                        className="forgot-password"
                        onClick={handleForgotPassword}
                      >
                        忘记密码？
                      </button>
                    )}
                  </div>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="输入你的密码"
                    className={`form-control ${errors.password ? 'error' : ''}`}
                  />
                  {errors.password && (
                    <div className="error-message">
                      <span className="error-icon">⚠️</span>
                      {errors.password}
                    </div>
                  )}
                  {authMode === 'register' && (
                    <div className="password-hint">
                      密码至少6位，包含字母和数字更安全
                    </div>
                  )}
                </div>

                {authMode === 'register' && (
                  <div className="form-group">
                    <label htmlFor="confirmPassword" className="form-label">
                      <span className="label-icon">🔁</span>
                      确认密码
                    </label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      placeholder="再次输入密码"
                      className={`form-control ${errors.confirmPassword ? 'error' : ''}`}
                    />
                    {errors.confirmPassword && (
                      <div className="error-message">
                        <span className="error-icon">⚠️</span>
                        {errors.confirmPassword}
                      </div>
                    )}
                  </div>
                )}

                {authMode === 'register' && (
                  <div className="form-group terms-group">
                    <label className="terms-label">
                      <input type="checkbox" className="terms-checkbox" required />
                      <span className="terms-text">
                        我已阅读并同意 <a href="/terms" className="terms-link">服务条款</a> 和 <a href="/privacy" className="terms-link">隐私政策</a>
                      </span>
                    </label>
                  </div>
                )}

                <button 
                  type="submit" 
                  className="btn btn-primary auth-submit-btn"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="loading-spinner"></span>
                      {authMode === 'login' ? '登录中...' : '注册中...'}
                    </>
                  ) : (
                    <>
                      <span className="btn-icon">{authMode === 'login' ? '🔑' : '✨'}</span>
                      {authMode === 'login' ? '登录账户' : '创建账户'}
                    </>
                  )}
                </button>
              </form>
            )}

            {/* 分割线 */}
            {authMode !== 'switch' && (
              <div className="divider">
                <span className="divider-text">或使用其他方式</span>
              </div>
            )}

            {/* 社交登录：切换账号模式不显示 */}
            {authMode !== 'switch' && (
              <div className="social-login">
                <button 
                  className="social-btn github"
                  onClick={() => handleSocialLogin('GitHub')}
                >
                  <span className="social-icon">🐱</span>
                  GitHub
                </button>
                <button 
                  className="social-btn google"
                  onClick={() => handleSocialLogin('Google')}
                >
                  <span className="social-icon">G</span>
                  Google
                </button>
                <button 
                  className="social-btn twitter"
                  onClick={() => handleSocialLogin('Twitter')}
                >
                  <span className="social-icon">🐦</span>
                  Twitter
                </button>
              </div>
            )}

            {/* 底部链接 */}
            <div className="auth-footer">
              {authMode !== 'switch' ? (
                <p>
                  {authMode === 'login' ? '还没有账户？' : '已有账户？'}
                  <button 
                    className="switch-link"
                    onClick={() => setAuthMode(authMode === 'login' ? 'register' : 'login')}
                  >
                    {authMode === 'login' ? '立即注册' : '立即登录'}
                  </button>
                </p>
              ) : (
                <p>
                  <button 
                    className="switch-link"
                    onClick={() => setAuthMode('login')}
                  >
                    返回登录
                  </button>
                </p>
              )}
              <p className="welcome-text">
                <span className="welcome-icon">🐕</span>
                小狗会一直在这里等你
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;